import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { MORNING_STAR_CATEGORY_KEY, MORNING_STAR_COMPONENT_KEY } from '../MorningStar.meta.js';

const starIcon = () => (
	<svg viewBox="0 0 1024 1024">
		<path d="M540.312 0l-111.753 350.685-436.534-3.507 352.719 256-160.644 420.822 356.212-259.507 324.781 227.945-129.214-389.26 352.719-256-436.534 3.507-111.753-350.685z"></path>
	</svg>
);

export default InjectedStyledComponent(starIcon, MORNING_STAR_CATEGORY_KEY, MORNING_STAR_COMPONENT_KEY, [
	'morningStarIcon',
]);
